import { Card } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import { fmtLongDate, RECITAL_L, TicketButton, CalendarButtons, Poster } from "./showsUtils";

// Titolo vero e locandina solo se lo spettacolo collegato è visibile e non ha il titolo provvisorio (deciso dal server)
const RecitalItem = ({ r }) => (
  <li className="rounded-xl border border-border bg-white p-4 space-y-2" data-testid={`my-recital-${r.kind}`}>
    <p className="text-xs uppercase tracking-widest text-muted-foreground">{RECITAL_L[r.kind]} · <span className="normal-case tracking-normal break-words">{r.course}</span></p>
    {r.title && <p className="text-lg font-semibold break-words" data-testid={`my-recital-title-${r.kind}`}>{r.title}</p>}
    {r.poster_url && <Poster key={r.poster_url} url={r.poster_url} title={r.title} testid={`my-recital-poster-${r.kind}`} maxH="max-h-96" />}
    <p className="text-xl sm:text-2xl font-bold leading-snug first-letter:uppercase break-words" data-testid={`my-recital-date-${r.kind}`}>{fmtLongDate(r.date)}{r.time ? `, ore ${r.time}` : ""}</p>
    {r.location && <p className="text-sm text-muted-foreground break-words" data-testid={`my-recital-location-${r.kind}`}>{r.location}</p>}
    {r.notes && <p className="text-sm text-foreground whitespace-pre-line break-words" data-testid={`my-recital-notes-${r.kind}`}>{r.notes}</p>}
    <TicketButton href={r.link} testid={`my-recital-tickets-${r.kind}`} />
    <CalendarButtons ics={r.ics} testid={`my-recital-cal-${r.kind}`} title={r.title || `${RECITAL_L[r.kind]} · ${r.course}`} date={r.date} time={r.time} location={r.location} details={r.notes} />
  </li>
);

// "I tuoi saggi": solo se il proprio corso ha almeno una data
export const MyRecitals = ({ info }) => {
  if (!info?.eligible || !info.recitals?.length) return null;
  return (
    <Card className="p-5 bg-card border-primary/40 border-2 space-y-3" data-testid="my-recitals">
      <h2 className="text-2xl flex items-center gap-2"><Sparkles size={20} className="text-primary shrink-0" /> I tuoi saggi</h2>
      <ul className="space-y-3">{info.recitals.map((r) => <RecitalItem key={r.kind} r={r} />)}</ul>
    </Card>
  );
};

// Scheda compatta per il calendario lezioni
export const RecitalStrip = ({ recitals }) => (recitals?.length ? (
  <div className="rounded-xl border border-primary/30 bg-primary/5 p-3 space-y-1" data-testid="my-calendar-recitals">
    {recitals.map((r) => (
      <p key={r.kind} className="text-sm break-words" data-testid={`my-calendar-recital-${r.kind}`}>
        <span className="text-muted-foreground">{RECITAL_L[r.kind]}:</span> <strong className="inline-block first-letter:uppercase">{fmtLongDate(r.date)}</strong>
      </p>
    ))}
  </div>
) : null);
